import React from 'react';
import { twMerge } from 'tailwind-merge';
interface PanelProps {
  children: React.ReactNode;
  className?: string;
  as?: 'div' | 'section' | 'article' | 'aside';
}
export function Panel({
  children,
  className,
  as = 'div'
}: PanelProps) {
  const Tag = as;
  return <Tag className={twMerge('rounded-card border border-line bg-surface shadow-card', className)} data-id="element-439" data-mp="2gkzr3r8zutli">
      {children}
    </Tag>;
}